let cachedToken = null

export default async function getCsrfToken() {
  const tag = document.querySelector('meta[name="csrf-token"]')
  if (tag) {
    return tag.getAttribute("content")
  }

  if (cachedToken !== null) {
    return cachedToken
  }

  let response = await fetch("/csrf_token", {
    credentials: "same-origin",
    method: "GET",
  })

  if (!response.ok) {
    throw new Error(`csrf token http error: ${response.status}`)
  }

  response = await response.json()
  cachedToken = response.csrf_token

  return cachedToken
}
